import "lazysizes";
import Alpine from "alpinejs";
import "./anchor-links";
import "./housing-map";
import "./momentum";
import "./mobile-nav";
import "./cookie-banner";

Alpine.store("momentum", {
  loginButton: "Logga in",
});

window.Alpine = Alpine;
Alpine.start();
